import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { CountryEnum } from '@ivario-arc/shared/src/enums';
import ShipmentButtons, {
  BackgroundColor,
} from '@components/atoms/ShipmentButtons';
import { ButtonType, SampleDto } from '@src/types/types';
import { ExternalLinks, Paths } from '@src/routes/paths';
import { Link } from '@components/atoms/Link';
import { Icon } from '@components/atoms/Icon';
import { IconType } from '@src/types/IconType';
import { Button } from '@components/atoms/Button';

export default function ShipmentInstructions({
  sample,
  background = 'white',
}: {
  sample: SampleDto;
  background?: BackgroundColor;
}) {
  const navigate = useNavigate();
  const { t } = useTranslation('component', {
    keyPrefix: 'shipmentInstructions',
  });

  const canGenerateShipmentLabel = [
    CountryEnum.Germany,
    CountryEnum.Austria,
  ].includes(sample.shippingCountry as CountryEnum);

  const shippingDataComplete =
    !!sample.shippingSenderLastName &&
    !!sample.shippingSenderFirstName &&
    !!sample.shippingStreetNumber &&
    !!sample.shippingStreet &&
    !!sample.shippingPostalCode &&
    !!sample.shippingCity &&
    !!sample.shippingCountry &&
    (!canGenerateShipmentLabel || sample.qrCodeURL || sample.shippingLabeURL);

  return (
    <div className="flex flex-row mt-6">
      {shippingDataComplete ? (
        canGenerateShipmentLabel ? (
          <ShipmentButtons sample={sample} background={background} />
        ) : (
          <div className="w-full flex space-x-2 items-center">
            <Icon
              type={IconType.Information}
              className="bg-ivarioBlue w-3.5 h-3.5"
            />
            <p className="w-full space-x-1 font-light">
              {t('foreignShippingInstructions')}{' '}
              <Link
                to={ExternalLinks.FOOTER_FAQ}
                target="_blank"
                className="font-bold underline"
              >
                {t('foreignShippingInstructionsLink')}
              </Link>
            </p>
          </div>
        )
      ) : (
        <Button
          label={t('addAddress')}
          buttonType={ButtonType.PRIMARY}
          onClick={() => navigate(`${Paths.SENDER_ADDRESS}/${sample.id}`)}
        />
      )}
    </div>
  );
}
